<template>
  <div class="index">
    <div class="two-big-title">Call For Papers</div>
    <div class="index-con">
      <div class="small-title">
        The topics of interest for submission include, but are not limited to:
      </div>
      <div class="lists">
        <div class="list">
          <div class="list-title cup" @click="show = !show">
            <p><span class="square"></span>Food Bioscience</p>
            <p class="f-18">{{ show ? "-" : "+" }}</p>
          </div>
          <div
            class="list-con"
            :style="{ height: show ? list1.length * 45 + 'px' : 0 }"
          >
            <div class="small-list" v-for="item in list1" :key="item + 'list1'">
              <span class="small-square"></span>
              {{ item }}
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list-title cup" @click="show1 = !show1">
            <p><span class="square"></span>Food Nutrition</p>
            <p class="f-18">{{ show1 ? "-" : "+" }}</p>
          </div>
          <div
            class="list-con"
            :style="{ height: show1 ? list2.length * 45 + 'px' : 0 }"
          >
            <div class="small-list" v-for="item in list2" :key="item + 'l2'">
              <span class="small-square"></span>
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
      show1: true,
      list1: [
        "Mechanisms of functional foods and ingredients",
        "Biochemical, biophysical and biological properties of foods",
        "Genetic, and cellular and molecular biology in food production and processing",
        "Foodomics",
        "Biomaterials for food-related systems",
        "Application of novel technology to foods",
        "Scientific writing and publication",
      ],
      list2: [
        "Development, stabilization, and industrial application of functional nutrients",
        "Nutrition for specific or special populations",
        "Nutritional issues in food storage, processing and the development of new food products",
        "Scientific writing and publication",
      ],
    };
  },
};
</script>


<style scoped lang="less">
.index {
  min-height: 800px;
}
.lists {
  width: 80%;
  margin: 0 auto;
  display: flex;
  .list {
    width: calc(50% - 35px);
  }
  .list:nth-of-type(1) {
    margin-right: 70px;
  }
  .f-18 {
    font-size: 18px;
  }
  .list-title {
    background: #28d6ec;
    display: flex;
    padding: 0 15px;
    box-sizing: border-box;
    height: 48px;
    font-weight: 600;
    justify-content: space-between;
    border-radius: 5px;
    align-items: center;
    color: #fff;
  }
  .list-title p {
    display: flex;
    align-items: center;
  }
  .list-con {
    height: 400px;
    transition: 0.3s all;
    overflow: hidden;
    padding-top: 10px;
    box-sizing: border-box;
  }
  .hide {
    height: 0;
  }
  .small-list {
    height: 45px;
    display: flex;
    align-items: center;
  }
  .square {
    width: 0;
    height: 0;
    display: inline-block;
    border: 9px solid transparent;
    border-left: 13px solid #fff;
  }
  .small-square {
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-left: 8px solid #333;
  }
}
.index-con {
  max-width: 1200px;
  margin: 0 auto;
}
.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-top: 35px;
  margin-bottom: 20px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .index {
    padding: 40px 10px 40px;
    box-sizing: border-box;
  }

  .title {
    font-size: 18px;
  }

  .people-list {
    width: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/session.vue